// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { ShaderModuleInstance } from "./shader-module-instance.js";
export function normalizeShaderModule(module) {
    if (!module.normalized) {
        module.normalized = true;
        if (module.uniformPropTypes && !module.getUniforms) {
            const shaderModule = new ShaderModuleInstance(module);
            module.getUniforms = shaderModule.getUniforms.bind(shaderModule);
        }
    }
    return module;
}
